import { MANAGED_STRUCTURE_TYPE_ID } from "theme/config/constants";
import getProductStockStatus from "core-web/utils/getProductStockStatus";

export default (product, query, isDistinct = true) => {
    const {
        categories,
        name,
        parentProductName,
        // parentProductId,
        campaignPrice,
        pricing,
        productId,
        categoryPrimary,
        campaignFlags = [],
        flags = [],
        manufacturer,
        url: originalUrl,
        parametrics,
        image,
        parentImage,
        objectID,
        onHand,
        type,
        all_variants: variantPartNos,
    } = product;

    const stockStatus = getProductStockStatus(onHand);
    const inStock = !!stockStatus.stock;
    const isPackage = type === MANAGED_STRUCTURE_TYPE_ID;
    const isVariant = variantPartNos?.length > 1;

    const { name: manufacturerName } = manufacturer || {};
    let presetPartNo = isDistinct ? null : objectID;

    if (!presetPartNo && query && variantPartNos.length > 1) {
        variantPartNos.forEach((partNo) => {
            if (partNo === query) {
                presetPartNo = partNo;
            }
        });
    }

    const productFlags = isDistinct ? flags.concat(campaignFlags) : flags;

    const vatRate = pricing?.vat;
    const priceListCode = pricing?.code;
    const priceListId = pricing?.price_list_id || product.pricelistId;
    const priceExVat = pricing?.pricelists?.web?.exVat;
    const standardPriceExVat = pricing?.standard?.exVat;

    const fromPriceExVat = pricing?.from?.exVat;
    const fromStandardPriceExVat = pricing?.standard_from?.exVat;

    const campaignPriceListCode = campaignPrice?.code;
    const campaignPriceListId = campaignPrice?.price_list_id;
    const campaignPriceExVat = campaignPrice?.pricelists?.web?.exVat;
    const campaignStandardPriceExVat = campaignPrice?.standard?.exVat;

    let priceExVatToShow = priceExVat;
    let standardPriceExVatToShow = standardPriceExVat;
    let priceListCodeToShow = priceListCode;
    let priceListIdToShow = priceListId;
    let fromPriceExVatToShow, fromStandardPriceExVatToShow;

    if (isDistinct) {
        if (campaignPriceExVat) {
            priceExVatToShow = campaignPriceExVat;
        } else if (fromPriceExVat) {
            fromPriceExVatToShow = fromPriceExVat;
        }

        if (campaignStandardPriceExVat) {
            standardPriceExVatToShow = campaignStandardPriceExVat;
        } else if (fromStandardPriceExVat) {
            fromStandardPriceExVatToShow = fromStandardPriceExVat;
        }

        if (campaignPriceListCode) {
            priceListCodeToShow = campaignPriceListCode;
        }
        if (campaignPriceListId) {
            priceListIdToShow = campaignPriceListId;
        }
    }

    const updatedUrl = variantPartNos?.length === 1 ? `${originalUrl}?p=${variantPartNos[0]}` : originalUrl;

    return {
        categories,
        partNo: objectID,
        name: isDistinct ? parentProductName || name : name || parentProductName,
        vatRate,
        priceExVat: priceExVatToShow,
        standardPriceExVat: standardPriceExVatToShow,
        fromExVat: fromPriceExVatToShow || null,
        standardFromExVat: fromStandardPriceExVatToShow || null,
        priceListCode: priceListCodeToShow,
        priceListId: priceListIdToShow,
        categoryPrimary,
        flags: productFlags,
        manufacturerName,
        url: updatedUrl,
        presetPartNo,
        parametrics,
        image,
        parentImage,
        // @todo: check parentProductId or something else variant defining
        isVariant,
        productId,
        stockStatus,
        inStock,
        isPackage,
    };
};
